import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import fromObjectToKeys from 'utils/converters/object/fromObjectToKeys.util';
import equalShallow from 'utils/objects/equalShallow.util';
import owns from 'utils/objects/owns.util';

const hasNo = (key, object) => {
  if (null === object) return true;
  if (void 1 === object) return true;

  return !owns(key, object);
};

const diffShallow = (a, b) => {
  if (Object.is(a, b)) return true;

  const keys = new Set([...fromObjectToKeys(a ?? {}), ...fromObjectToKeys(b ?? {})].map(String));

  const diff = [];
  for (const key of keys) {
    const valA = a?.[key];
    const valB = b?.[key];

    if (hasNo(key, a) || hasNo(key, b) || !equalShallow(valA, valB)) {
      diff.push([`${key}/1`, valA]);
      diff.push([`${key}/2`, valB]);
    }
  }

  return fromEntriesToObject(diff);
};

export default diffShallow;
